import { create } from 'zustand';

const useMigrateStore = create((set) => ({
  toggleFolder: false,
  handleToggleFolder: (param) =>
    set((state) => ({
      toggleFolder: param
    })),

  folderMode: 'source',
  handleFolderMode: (param) =>
    set((state) => ({
      folderMode: param
    })),
  choosenFolderSource: '',
  handleChoosenFolderSource: (param) =>
    set((state) => ({
      choosenFolderSource: param
    })),

  choosenFolderDestination: '',
  handleChoosenFolderDestination: (param) =>
    set((state) => ({
      choosenFolderDestination: param
    })),

  sourceProviderData: null,
  handleSourceProviderData: (param) =>
    set((state) => ({
      sourceProviderData: param
    })),

  destinationProviderData: null,
  handleDestinationProviderData: (param) =>
    set((state) => ({
      destinationProviderData: param
    })),

  hubname: '',
  setHubName: (name) =>
    set((state) => ({
      hubname: name
    })),

  projectName: '',
  setProjectName: (name) =>
    set((state) => ({
      projectName: name
    })),
  openProject: false,
  setOpenProject: () =>
    set((state) => ({
      openProject: true
    })),
  setCloseProject: () =>
    set((state) => ({
      openProject: false
    }))
}));

export default useMigrateStore;
